const getWindowWidth = (): number =>
	window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

export const getLoggingDeviceType = () => {
	const width = getWindowWidth();
	if (width < 768) return "mobile";
	if (width < 1024) return "tablet";

	return "desktop";
};
